<template>
    <v-container theme="light">
        <v-row class="contentRow">
            <v-col>
				<h1>Due Diligence Wheel</h1>
			</v-col>
            <p style="margin: 30px 100px;">The Yearly Due Diligence Wheel is a tool designed to identify and mitigate the risk of unethical business conduct within your supply chain. 
                Comprised of 6 steps represented in this pie chart, each slice of the chart can be clicked on to access specific tasks required for compliance 
                with various transparency laws and to complete the due diligence process. You will find comprehensive information on each step, including actionable 
                tasks and examples to ensure compliance.
            </p>
            <CirclechartComponent/>
            
            Use this <router-link style="margin: 0 5px;"
                        :to="{
                            path: '/knowledge',
                            query: {
                                article: 'Sustainability Tutorial',
                                doc: 'due-diligence-wheel'
                            }
                        }"
                        target="_blank">link
                    </router-link> to view the knowledge base of Orixe.
        </v-row>
    </v-container>
</template>

<script >
import CirclechartComponent from "../components/CirclechartComponent.vue"

export default {
	components: {
		CirclechartComponent,
	},
}
</script>
